import React from 'react';

import utilsService from '../../services/utilsService';

import './participantChatNameComponent.css';

const ParticipantChatNameComponent = ({participantName}) => {
  return participantName ? (
    <div
      className={`et-v2-participant-chat-name-container ${utilsService.getIsClient() ? 'et-v2-pcn-client-side' : ''}`}>
      {participantName}
    </div>
  ) : null;
};

export default ParticipantChatNameComponent;
